export function formatDuration(seconds: number, includeSeconds: boolean = true) {
  let value = Math.round(seconds)
  let res = ''

  // seconds
  if (includeSeconds) {
    res = ':' + twoDigits(value % 60)
  }
  value = ~~(value / 60) // integer division

  // minutes
  res = twoDigits(value % 60) + res
  value = ~~(value / 60) // integer division
  if (value === 0 && includeSeconds) { return res }

  // hours
  res = twoDigits(value % 24) + ':' + res
  value = ~~(value / 24) // integer division
  if (value === 0) { return res }

  return `${value}d, ${res}`

}

function twoDigits(num: number) {
  return num < 10 ? '0' + num : num.toString()
}

export function relativeFormatDuration(seconds: number) {
  let returnString = ''
  let secs = Math.round(seconds)

  if (secs >= 86400) {
    let days = Math.floor(secs / 86400);
    returnString += days + 'd, '
    secs = secs - (days * 86400)
  }

  if (secs >= 3600) {
    let hour = Math.floor(secs / 3600);
    returnString += hour + 'h '
    secs = secs - (hour * 3600)
  } else if (returnString !== '') {
    //returnString += '00h ';
  }

  if (secs >= 60) {
    let minutes = Math.floor(secs / 60);
    returnString += minutes + 'm'
    secs = secs - (minutes * 60)
  } else if (returnString !== '') {
    //returnString += '00m';
  }

  return returnString === '' ? '0m' : returnString
}
